import Api from '../http.service';
/**get all Wallet history
 * @param {Object} payload
 * @param {Object} payload.pageNumber
 * @param {Object} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.startDate
 * @param {String} payload.data.endDate
 * @param {String} payload.data.phrase
 * @param {Number} payload.data.walletStatusId
 */

export const getHistory = (payload) =>
  Api.POST({
    url: `wallet/history/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });

/**get all Wallet history
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {number} payload.data.amount
 * @param {string} payload.data.currencyId
 * @param {string} payload.data.description
 * @param {string} payload.data.callbackURL
 *
 */
export const charge = (payload) =>
  Api.POST({
    url: 'payment/wallet/deposit',
    data: {
      ...payload.data,
      callBackUrl: `${window.location.origin}/#/payment-result`,
    },
  });
export const paymentResult = (orderId) =>
  Api.GET({
    url: `payment/transaction/order/${orderId}`,
  });
